import { Component, OnInit } from '@angular/core';
import { IBillingDocument } from '@dch/billing-business-logic';
import { UtilsService } from '../services/utils.service';
import { BillingAnalyticsService } from '../services/billing-analytics.service';
import { Router } from '@angular/router';
import {
  DEFERRAL_SELECT_DATE_PAGE,
  OVERVIEW_PAGE,
} from '../config/my-bill.constants';
import { BillingBackToPreviousScreenService } from '../services/billing-back-to-previous-screen.service';
import { Store } from '@ngrx/store';
import { ApplicationState } from 'src/app/state/reducers';
import { selectCustomerAccount } from 'src/app/state/selectors/customer-account.selector';
import { OnDestroyHookDirective } from '../common/hooks';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'my-bill-deferral-landing-page',
  templateUrl: './deferral-landing-page.component.html',
  standalone: false,
})
export class DeferralLandingPageComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  readonly selectedCustomerAccount$ = this.store.select(selectCustomerAccount);
  constructor(
    private utilsService: UtilsService,
    private router: Router,
    private billingBackToPreviousScreenService: BillingBackToPreviousScreenService,
    private store: Store<ApplicationState>,
    private billingAnalyticsService: BillingAnalyticsService
  ) {
    super();
  }

  billDocument?: IBillingDocument;
  billingAccountNumber?: string;

  ngOnInit() {
    this.addSubscription(
      this.selectedCustomerAccount$
        .pipe(
          filter(
            (selectedCustomerAccount) => selectedCustomerAccount !== undefined
          ),
          tap((selectedCustomerAccount) => {
            const { billDocument, billingAccountNumber } =
              this.utilsService.getDeferralDocumentInfoFromStorage();
            if (billDocument !== undefined) {
              this.billDocument = billDocument;
              this.billingAccountNumber = billingAccountNumber;
              this.billingAnalyticsService.reportPageImpressionEvent(
                'deferral_landing',
                this.billDocument.reference,
                this.billingAccountNumber,
                undefined,
                selectedCustomerAccount.getSelectedCustomer().customerId,
                selectedCustomerAccount.getSelectedCustomer().subsegment,
                selectedCustomerAccount.globalId
              );
            } else {
              this.router.navigate([OVERVIEW_PAGE]);
            }
          })
        )
        .subscribe()
    );
  }

  onClickOnDelayPayment() {
    this.router.navigate([DEFERRAL_SELECT_DATE_PAGE]);
  }

  onClickOnCancelButton() {
    this.billingBackToPreviousScreenService.goBack();
  }
}
